import { DialogOptions } from '../../../models/modal.model'
import {
  GenericNotificationCode,
  NotificationOptions,
  parseGenericNotification,
} from '../../../models/notification.model'
import { Brand } from '../models/brand.entity'

export type BrandNotificationCode =
  | GenericNotificationCode
  | 'BRAND_DELETED'
  | 'BRAND_SAVED'

export type BrandModalCode = 'BRAND_DELETION'

/**
 * Parse brand code to a notification
 * @param code - the brand notification code
 * @returns the notification options
 */
export function parseBrandNotification(
  code?: BrandNotificationCode,
): NotificationOptions {
  switch (code) {
    case 'BRAND_DELETED':
      return {
        message: 'Brand deleted successfully',
        color: 'success',
      }
    case 'BRAND_SAVED':
      return {
        message: 'Brand saved successfully',
        color: 'success',
      }
    default:
      return parseGenericNotification(code)
  }
}

/**
 * Parse brand code to an modal
 * @param code - the brand modal code
 * @param brand - the brand object
 * @returns the modal settings
 */
export function parseBrandModal(
  code: BrandModalCode,
  brand?: Brand,
): DialogOptions {
  switch (code) {
    case 'BRAND_DELETION': {
      const brName = brand?.name
      return {
        title: 'Delete brand',
        message:
          'You are about to delete the brand <strong>%s</strong>. Proceed with deletion?',
        messageParams: brName ? [brName] : undefined,
        buttons: ['Cancel', 'Confirm'],
      }
    }

    default:
      return {}
  }
}
